import { createSelector } from 'reselect';

import { getSystem } from './system.selectors';

const selectAiPersonasState = createSelector(getSystem, ({ aiPersonas }) => aiPersonas);

export const selectAiPersonas = createSelector(
  selectAiPersonasState,
  ({ aiPersonas }) => aiPersonas,
);

export const selectAiPersonaById = id =>
  createSelector(selectAiPersonas, aiPersonas => aiPersonas.find(persona => persona.id === id));

export const selectGlobalAiPersonas = createSelector(
  selectAiPersonasState,
  ({ globalAiPersonas }) => globalAiPersonas,
);

export const selectSecurityGroupIdsByPersonaId = createSelector(
  selectAiPersonasState,
  ({ securityGroupIdsByPersonaId }) => securityGroupIdsByPersonaId,
);

export const selectPersonaSecurityGroupIds = personaId =>
  createSelector(
    selectSecurityGroupIdsByPersonaId,
    securityGroupIdsByPersonaId => securityGroupIdsByPersonaId[personaId] || null,
  );
